<template>
  <div>
    <el-button plain @click="show_clock_time = !show_clock_time" size="mini">
      {{ show_clock_time ? 'show real work time' : 'show clock time' }}
    </el-button>
    <CommitmentVisualBar
      style="padding: 0.9em; padding-bottom: 0.4em"
      :max-value="visual_bar_max_minutes"
      :percents="percents"
      :color-map="color_map"
      unit="min" />

    <div class="clearfix" v-show="debug_show_color_test">
      <div
        v-for="x in [0.0,0.1,0.2,0.3,0.4,0.5,0.6,0.7,0.8,0.9,1.0]"
        :key="x"
        :style="{
          color: 'white',
          float: 'left',
          backgroundColor: mixColorsByProgress(x),
          width: '40px',
          height: '40px'
        }">{{x}}</div>
    </div>
  </div>
</template>

<script>

// TODO: if pausde show differently
// TODO: if negative remaining time show flashing animation

import { mapGetters } from 'vuex'
import CommitmentVisualBar from '@/components/Elements/CommitmentVisualBar'
import Color from 'color';
import moment from '@/moment-gp.js';

export default {
  props: {
    sessionId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      show_clock_time: true,
      debug_show_color_test: false
    }
  },
  computed: {
    ...mapGetters("calendar",[
      "event_by_id"
    ]),
    ...mapGetters("session",[
      "time_spend_in_session",
      "elapsed_time_in_session",
      "remaining_time_in_session",
    ]),

    session() {
      if ( this.sessionId ) {
        return this.event_by_id( this.sessionId );
      } else {
        return null;
      }
    },

    visual_bar_max_minutes() {
      /* TODO: MOVE TO GETTER */
      let end = moment( this.session.userEnd );
      let start = moment( this.session.userStart );
      let duration = moment.duration(end.diff(start));
      return duration.asMinutes();
    },

    percents() {
      if ( this.show_clock_time ) {
        return [ Math.round( this.elapsed_time_in_session / 60 ) ];
      } else {
        return [
          Math.round( this.time_spend_in_session.corrected / 60 ),
          Math.round( this.time_spend_in_session.paused / 60 )
        ];
      }
    },

    color_map() {
      let progress = this.percents[0] / this.visual_bar_max_minutes;
      return [ this.mixColorsByProgress(progress), 'black' ];
    }
  },
  methods: {
    mixColorsByProgress(progress) {
      let base = Color.rgb(200,200,200);
      base = base.mix(Color("#FF6611"), progress).mix(Color("green"), 1 - progress);
      return base.string();
    }
  },
  components: {
    CommitmentVisualBar
  }
}
</script>
